export const ADD_PLAYER = "ADD_PLAYER";
export const RESET_PLAYER = "RESET_PLAYER";
export const GAME_CHANGE_PLAYER = "GAME_CHANGE_PLAYER";
export const CLEAR_SCORECARD = "CLEAR_SCORECARD";
export const HIDE_LANE = "HIDE_LANE";
const initState = [];

// const addOrReplace = (array, item) => {
//   const i = array.findIndex(
//     (laneThrow) =>
//       laneThrow.lane === item.lane &&
//       laneThrow.bowlingCenterUuid === item.bowlingCenterUuid &&
//       (laneThrow.playerName === item.playerName ||
//         laneThrow.playerNumber === item.playerNumber)
//   );
//   if (i > -1) array[i] = item;
//   else array.push(item);
// };

export function playersLanes(store) {
  store.on("@init", () => ({ players: initState }));

  const addOrReplace = (array, item) => {
    const i = array.findIndex(
      (laneThrow) =>
        laneThrow.lane === item.lane &&
        laneThrow.bowlingCenterUuid === item.bowlingCenterUuid &&
        (laneThrow.playerName === item.playerName ||
          laneThrow.playerNumber === item.playerNumber)
    );
    if (i > -1) {
      // is new team to the lane?
      if (
        array[i].playerName !== item.playerName ||
        array[i].teamName !== item.teamName
      ) {
        const temp = array.filter((i) => i.lane !== item.lane);
        array = [...temp];
        array.push(item);
      } else {
        array[i] = item;
      }
    } else array.push(item);

    return array;
  };

  store.on(ADD_PLAYER, ({ players }, laneThrow) => {
    let temp = [...players];
    if (laneThrow) {
      temp = addOrReplace(temp, laneThrow);
    }

    return { players: [...temp] };
  });

  store.on(GAME_CHANGE_PLAYER, ({ players }, player) => {
    // is new team to the lane?
    const i = players.findIndex(
      (laneThrow) =>
        laneThrow.lane === player.lane &&
        laneThrow.bowlingCenterUuid === player.bowlingCenterUuid &&
        laneThrow.playerNumber === player.playerNumber &&
        laneThrow.playerName !== player.playerName
    );

    let temp;

    if (i > -1) {
      temp = players.filter((i) => i.lane !== player.lane);
      temp.push(player);
    } else {
      temp = players.map((e) => {
        return e.lane === player.lane &&
          e.bowlingCenterUuid === player.bowlingCenterUuid
          ? e.playerNumber === player.playerNumber
            ? player
            : { ...e, throws: [], pins: [], scores: [] }
          : e;
      });
    }
    return { players: [...temp] };
  });

  store.on(RESET_PLAYER, ({ players }) => {
    return { players: [] };
  });

  store.on(CLEAR_SCORECARD, ({ players }, { bowlingCenterUuid, lane }) => {
    const newPlayersScores = players.map((player) => {
      const flag =
        player.bowlingCenterUuid === bowlingCenterUuid && player.lane === lane;
      return {
        ...player,
        throws: flag ? [] : [...player.throws],
        pins: flag ? [] : [...player.pins],
        scores: flag ? [] : [...player.scores],
        game: player.game + 1,
      };
    });
    return { players: [...newPlayersScores] };
  });

  store.on(HIDE_LANE, ({ players }, { bowlingCenterUUID, lane }) => {
    const newPlayers = [...players].filter((item) => {
      return !(
        item.bowlingCenterUuid === bowlingCenterUUID && item.lane === lane
      );
    });

    return {
      players: [...newPlayers],
    };
  });
}
